import { useEffect } from "react";
import { useAuth } from "@/hooks/auth";
import { notificationsService } from "@/services/supabase/notifications";

/**
 * A component that initializes the notification system
 * This should be placed high in the component tree
 */
const NotificationInitializer = () => {
  const { user } = useAuth();

  // Set up real-time notification subscription for authenticated users
  useEffect(() => {
    if (!user?.id) return;

    // Subscribe to real-time notifications
    const subscription = notificationsService.subscribeToNotifications(
      user.id,
      (notification) => {
        // You can add additional logic here to show toast notifications, etc.
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [user?.id]);

  // No UI to render
  return null;
};

export default NotificationInitializer;
